import React from 'react';
import { Link as GatsbyLink, GatsbyLinkProps, graphql } from 'gatsby';
import { getUri } from '@/utils/routing';
import { compose, LayoutProps, layout, space, SpaceProps } from 'styled-system';
import styled from 'styled-components';

interface ALinkProps extends Omit<GatsbyLinkProps<any>, 'to'>, SpaceProps, LayoutProps {
  href: string
}

interface GLinkProps extends GatsbyLinkProps<any>, SpaceProps, LayoutProps {}

const alink: React.FC<ALinkProps> = ({
  href,
  children,
  innerRef,
  ...other
}) => (
  <a href={href} ref={innerRef} {...other}>
    {children}
  </a>
)

const linkCompose = compose(space, layout)
const GLink = styled(GatsbyLink)<GLinkProps>(linkCompose)
const ALink = styled(alink)<ALinkProps>(linkCompose)

const Link = React.forwardRef(
  (
    props: Omit<GatsbyLinkProps<unknown>, 'ref'>,
    ref: React.Ref<HTMLAnchorElement>
  ) => {
    const { to, url, activeClassName, partiallyActive, type, internal, targetBlank, ...other } = props

    // Use Gatsby Link for internal links, and <a> for others
    if (type === 'internal') {
      const file = /\.[0-9a-z]+$/i.test(to);

      if (file) {
        return <ALink href={to} innerRef={ref} {...other} />
      }
      const uri = getUri(internal?.slug?.current, internal?.type);
      return (
        <GLink
          to={uri}
          activeClassName={activeClassName}
          partiallyActive={partiallyActive}
          innerRef={ref}
          target={targetBlank ? '_blank' : ''}
          {...other}
        />
      )
    }
    return <ALink href={url} innerRef={ref} target={targetBlank ? '_blank' : ''} {...other} />
  }
)

export default Link;

export const query = graphql`
  fragment Link on SanityLink {
      url
      type
      targetBlank
      internal {
        ... on SanityPage {
          _type
          slug {
            current
          }
        }
        ... on SanityPost {
          _type
          slug {
            current
          }
        }
        ... on SanityProduct {
          _type
          slug {
            current
          }
        }
      }
    }
`
